import React from 'react';

export const renderArrayItems = (items?: string | string[]): string => {
  if (Array.isArray(items)) {
    return items.join(', ');
  } else if (typeof items === 'string') {
    return items.replace(/^\[|\]$/g, '');
  } else {
    return 'N/A';
  }
};

export const renderReferences = (reference: string | string[] | undefined | boolean): React.ReactElement | string => {
  if (!reference || typeof reference === 'boolean') return 'N/A';
  const raw = Array.isArray(reference) ? reference : reference.split(',');
  // Display in proper order (API/store may provide reverse order)
  const references = [...raw].reverse();
  return (
    <ul className="list-disc pl-5">
      {references.map((ref, index) => {
        const trimmed = ref.trim();
        const isPrimary = index === 0;
        return (
          <li key={index} className={isPrimary ? 'font-semibold' : ''}>
            <a
              href={trimmed}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              {trimmed}
            </a>
            {isPrimary && <span className="ml-1 text-muted-foreground font-normal">(Primary)</span>}
          </li>
        );
      })}
    </ul>
  );
};

export const formatTimestamp = (timestamp: Date | undefined): string => {
  if (!timestamp) return 'N/A';
  return new Date(timestamp).toISOString().split('T')[0]; // This will return the date in yyyy-mm-dd format
};

export const formatNumber = (num: number | undefined): string => {
  if (num === undefined) return 'N/A';
  return num.toLocaleString('en-US');
};
